import React, { ReactNode, useId } from 'react';
import styles from './RadioButton.module.scss';

type RadioButtonPropType = {
  label?: ReactNode;
  pinString?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  handleRadioSelect?: () => void;
  inputClassName?: string;
  labelClassName?: string;
  isMultiSelect?: boolean;
  inputName?: string;
  inputRef?: React.Ref<HTMLInputElement>;
  id?: string;
  choiceLabledby?: string;
};

function RadioButton(props: RadioButtonPropType) {
  const generatedId = useId();
  const {
    label,
    isChecked,
    isDisabled,
    handleRadioSelect,
    inputClassName = '',
    labelClassName = '',
    isMultiSelect = false,
    inputName = 'radio-select',
    inputRef,
    id,
    choiceLabledby
  } = props;
  const formInputUniqueId = id ?? generatedId;

  return (
    <>
      <input
        ref={inputRef}
        type={isMultiSelect ? 'checkbox' : 'radio'}
        name={inputName}
        id={formInputUniqueId}
        aria-labelledby={(choiceLabledby ?? "")}
        className={`${styles.radioInput} ${
          isMultiSelect ? styles.checkboxInput : styles.radioOnly
        } ${isChecked ? styles.checkedInput : ''} ${inputClassName} `}
        onChange={handleRadioSelect}
        disabled={isDisabled}
        checked={Boolean(isChecked)}
      />
      {
        label ? 
          <label
            htmlFor={formInputUniqueId}
            className={`${
              isDisabled ? 'cursor-not-allowed' : 'cursor-pointer'
            } inline-block w-full ${labelClassName}`}
          >
            {label}
          </label> 
        : null
      }
    </>
  );
}

export default RadioButton;
